import { PVSServiceStrategy } from '@/models/PVSStrategy.ts';
import { PVSProvider } from '@/models/customers/PVSProvider.ts';

import { data_cur_service_strategy } from '@/services/pvsStrategy/dataCurStrategy.ts';
import { doc_cirrus_service_strategy } from '@/services/pvsStrategy/docCirrusStrategy.ts';

export const getPVSServiceStrategy = (provider: PVSProvider): PVSServiceStrategy => {
    switch (provider) {
        case PVSProvider.DOC_CIRRUS: {
            return doc_cirrus_service_strategy;
        }
        case PVSProvider.DATA_CUR: {
            return data_cur_service_strategy;
        }
        default: {
            throw new Error(`Unsupported PVS provider: ${provider}`);
        }
    }
};
